export const PRIMARY_COLOR = 'rgb(0, 182, 182)';
export const PRIMARY_COLOR_HIGHLIGHT = 'rgb(0, 170, 170)';